import { IotsVolumeByStatusBarChart } from '@frontend/chart/components';
import { FormattedMessage, useIntl } from 'react-intl';

import { StatisticsCard } from '../../shared';
import { getIotStatusColor, getIotStatusDisplayLabel } from '../iot-status-display';
import { useLast30DaysHardwareIotsVolumeByStatusBarChart } from './use-last-30-days-hardware-iots-volume-by-status-bar-chart';

export interface Last30DaysHardwareIotsVolumeByStatusBarChartProps {
    accountId: string;
}

export const Last30DaysHardwareIotsVolumeByStatusBarChart = (props: Last30DaysHardwareIotsVolumeByStatusBarChartProps) => {
    const intl = useIntl();
    const { data, isLoading } = useLast30DaysHardwareIotsVolumeByStatusBarChart(props);

    return (
        <StatisticsCard
            chartKey={IotsVolumeByStatusBarChart.definition.key}
            title={
                <FormattedMessage
                    id='platform.statistics.hardware.last-30-days-hardware-iots-volume-by-status-bar-chart.title'
                    description='Title of the hardware insights stacked bar chart showing IoT status mix over the last 30 days'
                    defaultMessage='Status mix over time'
                />
            }
            subtitle={
                <FormattedMessage
                    id='platform.statistics.hardware.last-30-days-hardware-iots-volume-by-status-bar-chart.subtitle'
                    description='Subtitle for the hardware status mix chart indicating the last 30 days window'
                    defaultMessage='Last 30 days'
                />
            }
            isLoading={isLoading}
            hasData={!!data}>
            {data && (
                <div className='mt-auto h-full min-h-0 w-full flex-1'>
                    <IotsVolumeByStatusBarChart
                        data={data}
                        minHeight={80}
                        chartOptions={{
                            colors: data.series.map((series) => getIotStatusColor(series.name)),
                            legend: {
                                formatter: (seriesName) => getIotStatusDisplayLabel(seriesName, intl)
                            },
                            tooltip: {
                                y: {
                                    title: {
                                        formatter: (seriesName) => getIotStatusDisplayLabel(seriesName, intl)
                                    }
                                }
                            }
                        }}
                    />
                </div>
            )}
        </StatisticsCard>
    );
};
